import { load } from "scrivito"
import {
  InstallationReferenceObj,
  InstallationReferenceObjClass
} from "scrivito/Objs/InstallationReference/InstallationReferenceObjClass"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantObj } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"

export async function fetchInstallationReferencesByProducts(
  products: (ProductObj | ProductBaseVariantObj)[] | null | undefined
): Promise<InstallationReferenceObj[] | null> {
  if (!products || products.length === 0) {
    return null
  }

  return load(
    () =>
      InstallationReferenceObjClass.where(
        "product",
        "refersTo",
        products
      ).toArray() as InstallationReferenceObj[]
  )
}
